<ng-template #buttonContent>
    <span class="indicator__area" *ngIf="icon !== 'person-image'">
        <app-icon matTooltipClass="sidebar_tooltip" [matTooltip]="'My Profile'"
            matTooltipPosition="below" *ngIf="icon" [ngClass]="{'indicator__icon': iconWhenOpen}" [name]="icon"
            size="30"></app-icon>
        <app-icon *ngIf="iconWhenOpen" class="indicator__icon indicator__icon--open" [name]="iconWhenOpen"
            size="20"></app-icon>
        <span *ngIf="counter !== null" class="indicator__value">{{ counter }}</span>
    </span>
    <span *ngIf="icon === 'person-image'" matTooltipClass="sidebar_tooltip" [matTooltip]="'My Profile'"
        matTooltipPosition="below">
        <img class="mobile_person_icon_male" *ngIf="sessionDataString.gender == '1' && !userImage"
            src="./../../../../../assets/images/svg/male.svg" />
        <img class="mobile_person_icon_female" *ngIf="sessionDataString.gender == '2' && !userImage"
            src="./../../../../../assets/images/svg/female.svg" />
        <img class="base_icon" *ngIf="userImage" src="{{userImage}}">
    </span>
</ng-template>

<button *ngIf="link === null" type="button" class="indicator__button" (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</button>

<a *ngIf="link !== null && trigger === 'click'" [href]="link" class="indicator__button" (click)="onClick($event)"
    (appTouchClick)="onTouchClick($event)">
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</a>

<a *ngIf="link !== null && trigger !== 'click'" [routerLink]="link" class="indicator__button" (click)="onClick($event)"
    (appTouchClick)="onTouchClick($event)">
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</a>

<div class="indicator__dropdown" #dropdownElement>
    <ng-content></ng-content>
</div>